<template>
  <div id="app" class="app-root">
    <HeaderComponent />

    <main class="app-main">
      <div class="container">
        <router-view />
      </div>
    </main>

    <FooterComponent />

    <!-- Botão flutuante WhatsApp -->
    <a
      href="https://wa.me/5516993421030"
      target="_blank"
      rel="noopener"
      class="pw-whats-fab"
    >
      <span class="pw-whats-dot"></span>
      <span class="pw-whats-text">Falar no WhatsApp</span>
    </a>
  </div>
</template>

<script>
import AOS from "aos";
import HeaderComponent from "./components/HeaderComponent.vue";
import FooterComponent from "./components/FooterComponent.vue";

export default {
  name: "App",
  components: {
    HeaderComponent,
    FooterComponent,
  },
  mounted() {
    AOS.init({
      duration: 800,
      once: true,
      easing: "ease-out-quart",
      offset: 80,
    });
  },
};
</script>

<style>
/* ============ RESET & BASE GLOBAL ============ */
*,
*::before,
*::after {
  box-sizing: border-box;
}

html,
body,
#app {
  margin: 0;
  padding: 0;
  height: 100%;
}

body {
  font-family: "Poppins", system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI",
    sans-serif;
  background: radial-gradient(circle at top, #1f2937 0, #020617 45%, #000 100%);
  color: #e5e7eb;
}

/* Variáveis de tema */
:root {
  --pw-bg: #020617;
  --pw-bg-elevated: #020617;
  --pw-surface: #0b1120;
  --pw-surface-soft: #020617;
  --pw-primary: #8b5cf6;
  --pw-primary-soft: rgba(139, 92, 246, 0.18);
  --pw-accent: #22d3ee;
  --pw-accent-soft: rgba(34, 211, 238, 0.18);
  --pw-border-subtle: rgba(148, 163, 184, 0.25);
  --pw-text: #f9fafb;
  --pw-muted: #9ca3af;
  --pw-radius-lg: 18px;
  --pw-radius-xl: 24px;
  --pw-shadow-soft: 0 18px 45px rgba(15, 23, 42, 0.75);
}

/* Layout principal */
.app-root {
  min-height: 100vh;
  background:
    radial-gradient(circle at 0% 0%, rgba(34, 211, 238, 0.25), transparent 55%),
    radial-gradient(circle at 100% 0%, rgba(139, 92, 246, 0.35), transparent 55%),
    radial-gradient(circle at 50% 100%, rgba(15, 23, 42, 0.95), #020617 70%);
  color: var(--pw-text);
  display: flex;
  flex-direction: column;
}

.app-main {
  flex: 1;
  padding: 40px 0 56px;
}

/* Container global */
.container {
  width: 100%;
  max-width: 1120px;
  margin: 0 auto;
  padding: 0 1.5rem;
}

/* Utilitários */
.section-title {
  font-size: 1.8rem;
  font-weight: 600;
  margin-bottom: 0.75rem;
  letter-spacing: 0.05em;
  text-transform: uppercase;
  color: var(--pw-accent);
}

.section-subtitle {
  color: var(--pw-muted);
  font-size: 0.95rem;
  margin-bottom: 2rem;
}

/* Botão flutuante WhatsApp */
.pw-whats-fab {
  position: fixed;
  right: 1.75rem;
  bottom: 1.75rem;
  z-index: 60;
  display: inline-flex;
  align-items: center;
  gap: 0.65rem;
  padding: 0.55rem 1rem 0.55rem 0.7rem;
  background: radial-gradient(circle at 0 0, #22c55e, #16a34a);
  border-radius: 999px;
  color: #ecfdf5;
  text-decoration: none;
  font-size: 0.85rem;
  font-weight: 500;
  box-shadow: 0 18px 35px rgba(22, 163, 74, 0.65);
  border: 1px solid rgba(187, 247, 208, 0.2);
  transform-origin: center;
  transition:
    transform 0.18s ease-out,
    box-shadow 0.18s ease-out,
    background 0.18s ease-out;
}

.pw-whats-fab:hover {
  transform: translateY(-2px) scale(1.03);
  box-shadow: 0 24px 50px rgba(22, 163, 74, 0.85);
}

.pw-whats-dot {
  width: 26px;
  height: 26px;
  border-radius: 999px;
  background: radial-gradient(circle at 30% 20%, #bbf7d0, #16a34a);
  box-shadow: 0 0 18px rgba(22, 163, 74, 0.8);
  position: relative;
}

.pw-whats-dot::before,
.pw-whats-dot::after {
  content: "";
  position: absolute;
  border-radius: inherit;
  inset: 3px;
  border: 2px solid rgba(22, 101, 52, 0.7);
}

.pw-whats-text {
  white-space: nowrap;
}

/* Responsivo */
@media (max-width: 768px) {
  .app-main {
    padding-top: 28px;
    padding-bottom: 80px;
  }

  .container {
    padding: 0 1.1rem;
  }

  .pw-whats-text {
    display: none;
  }

  .pw-whats-fab {
    padding: 0.5rem;
  }
}
</style>
